// Module
var code = `<div class="deck-stack-slot deck-stack-slot--left"></div>
<div class="deck-stack-arrow" aria-hidden="true"></div>
<div class="deck-stack-slot deck-stack-slot--right"></div>
`;
// Exports
module.exports = code;